import { PASSPHRASE_FLOW } from '@hedepy/common/enums/PASSPHRASE_FLOW'
import type { PassphraseVerification } from '@hedepy/common/schemas/routes/octopus/v1/encryption'

export const isAiPassphraseRecoverable = (
  verification: PassphraseVerification | null | undefined,
): verification is PassphraseVerification & { flow: PASSPHRASE_FLOW.SYMMETRIC_KEY } =>
  verification?.flow === PASSPHRASE_FLOW.SYMMETRIC_KEY
